import { REACT_APP_ARPS_BASE_URL } from "../utils/urls";

const fetchAllSegments = async () => {
  const response = await fetch(`${REACT_APP_ARPS_BASE_URL}/segments`);
  const result = await response.json();
  return result;
};

export default fetchAllSegments;
